import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import * as msgs from "../../constants/textConstants";
import { Typography, Button, Card, Icon } from "../ecosystem/";

const InHomeCard = ({ history, cardHeader, editClick, cardSubContent, screenBreakPoint }) => {

    const [clickCard, setClickCard] = useState(false);

    const isMobileSize = (screenBreakPoint === msgs.XS_MOBILE || screenBreakPoint === msgs.SM_MOBILE) ? true : false;

    const onClickEdit = () => {
        let editClicked = `${editClick}`
        history.push(editClicked);
    }

    const onClickCard = () => {
        setClickCard(true)
    }

    return (<>
        {clickCard ?
            <div className="inhome-card-wrapper">
                <Card className="confirm-flip-card">
                    <div className="confirm-flip-card--header">
                        <Typography
                            type="body-02"
                            bold
                            color={"$color-primary-c1"}
                            tag="div"
                            textAlign="center"
                        >
                            Editing this field may affect your other selections.
                        </Typography>
                    </div>
                    <div className="row">
                        <div className="col-12 confirm-flip-card--buttons">
                            <Button
                                fluid
                                colorStyle="inverse"
                                variant="secondary"
                                onClick={() => setClickCard(false)}
                            >
                                Keep scheduling
                            </Button>
                            <Button
                                fluid
                                colorStyle="inverse"
                                onClick={() => onClickEdit()}
                            >
                                Edit
                            </Button>
                        </div>
                    </div>
                </Card>
            </div> :
            <div className="inhome-card-wrapper">
                <Card className="confirm-detail-card" onClick={() => onClickCard()} button={true}>
                    <div class="confirm-detail-card__content">
                        <Typography
                            type={isMobileSize ? "body-02" : "heading-02" }
                            bold
                            color={"$color-primary-a3"}
                            tag="div"
                        >
                            {cardHeader}
                        </Typography>
                        <Typography
                            type="body-02"
                            tag="div"
                        >
                            {cardSubContent}
                        </Typography>
                    </div>
                    <div className="confirm-detail-card__icon">
                        <div>
                            <span className="check-icon-style"><Icon name="check" color={"$color-system-a1"} /></span>
                            <span className="edit-icon-style"><Icon name="edit" color={"$color-primary-a3"} /></span>
                        </div>
                        <div className="edit-button">
                            <Typography type="cta-03" color="$color-primary-a3" bold>
                                Edit
                            </Typography>
                        </div>
                    </div>
                </Card>
            </div>
        }
    </>


    );
}


const mapStateToProps = state => {

    return {
        history: state.session.history,
        screenBreakPoint: state.common.screenBreakPoint,
    }
}

const mapDispatchToProps = dispatch => {
    return {
       
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeCard);